import React, {useContext, useEffect, useState} from "react";
import { Col, Container, Row } from "react-bootstrap";
import Loader from "../../assets/loading.gif";
import { Section } from "../Common/PageElement";
import { LoadBar, LoadImg, LoadLogo, LoadText } from "./StyledLoader";
import {LoadContext} from "../../context/LoadContext";
import axios from "axios";
import {INTERMEDIATE_API, PROGRESS_CHECK, QUEUE_CHECK, SERVER_URL} from "../../services/Config";
import {useHistory, useRouteMatch} from "react-router-dom";
import {
    ANNOTREE_INTERMEDIATE,
    INTERMEDIATE_APPLICATION,
    ANNOTOOL_APPLICATION,
    STOP_LOADER, UPLOAD_APPLICATION, ANNOTOOL_INTERMEDIATE
} from "../../services/Constant";



const Loading = () => {
    const { load,setLoad } = useContext(LoadContext);


    // const [curStatus,setCurStatus] = useState('-1')

    const [ifLoad, setIfLoad] = useState(true);
    const [progress, setProgress] = useState(0);
    const [except, setExcept] = useState(false);

    const [queueLength,setQueueLength] = useState(0)
    const [estimateTime,setEstimateTime] = useState(0)

    let history = useHistory();
    // let { path } = useRouteMatch();

    var steps = 100;
    const genomeLimit = '2000';

    const estimateEach = 6;

    let interval = undefined;
    let queueInterval = undefined



    useEffect(() => {
        // console.log('load state:')
        // console.log(load)

        // only work when value == 1, means diamond search
        if (load['value'] === ANNOTREE_INTERMEDIATE) {
            checkProgress()
        }

        if (load['value'] === ANNOTOOL_INTERMEDIATE) {

        }
    }, []);



    const checkProgress = () =>{
        const formData = new FormData();

        // console.log('progress check')

        formData.append("token", load['token']);
        formData.append("database", load['database']);
        formData.append("limit", genomeLimit);

        axios
            .post(SERVER_URL + PROGRESS_CHECK, formData)
            .then((response) => {

                // console.log(response.data)
                // console.log(load)

                // respond_value = {'cur_progress': 0,'total_block':0}

                let curProgress = response.data.cur_progress
                let totalBlock = response.data.total_block

                let curPro = Math.round(curProgress/totalBlock * 100)

                // clearInterval(interval);

                if(curProgress !== 0 && totalBlock!== 0){
                    // console.log(curPro)
                    setProgress(curPro)
                }

                // if(curStatus === '1'){
                //     return
                // }

                if(response.data.status === '0'){
                    // console.log('task is running')
                    setTimeout(checkProgress, 4*1000);
                    return
                }
                else if(response.data.status === '-1'){
                    // console.log('task is in queue...')
                    setTimeout(checkProgress, 4*1000);
                    return
                }

                // console.log(response.data.status)
                if(curPro >= 100 || response.data.status === '1'){
                // if(curPro >= 100 || response.data.status === '1'){

                    // setLoad({'value':1,'token':load['token']});

                    // console.log('call clear')
                    // setCurStatus('1')
                    // clearInterval(interval);
                    setLoad(prev=>{
                        return {
                            'value':STOP_LOADER,
                            'token':prev['token'],
                            'database':prev['database'],
                            'path':prev['path']}
                    })


                    history.push({
                        pathname: `${load['path']}/intermediate`,
                        state: {
                            intermediateData: response.data.track_data,
                            token: load['token'],
                            databaseValue: load['database'],
                            debug: true,
                            userEmail:'',
                            limit_level: response.data.limit_level
                        },
                    });


                }

            })
            .catch((e) => {
                // alert("Progress check error");
                console.log(e);
                if(e.response && e.response.status === 400){
                    setTimeout(checkProgress, 4*1000);
                }
                else{
                    console.log('react: progress check error')
                    setTimeout(checkProgress, 4*1000);
                }

            });
    }


    const getDataForAnnotool = ()=> {
    }



    const showText = () =>{
        // console.log(load)
        if(load['value'] === ANNOTREE_INTERMEDIATE){
            return "Searching GTDB genome database for matches to your query sequence"
        }
        else if(load['value'] === INTERMEDIATE_APPLICATION){
            return "Retrieving gene neighborhoods containing your query gene"
        }
        else if(load['value'] === ANNOTOOL_APPLICATION){
            return "Fetching......"
        }
        else if(load['value'] === UPLOAD_APPLICATION){
            return "Fetching......"
        }
        else if(load['value'] === ANNOTOOL_INTERMEDIATE){
            return "Retrieving gene neighborhoods containing your query gene combinations"
        }
        else{
            return ""
        }

    }

    return (
        <Section center>
            <Container className="loading-container">
                <Row>
                    <Col>
                        {/*<div>*/}
                        {/*    <p style={{ fontSize: '16px' }}>*/}
                        {/*        There are {queueLength} requests using Diamond search*/}
                        {/*    </p>*/}

                        {/*</div>*/}
                        <LoadImg src={Loader} alt="loading-dna" />
                        <LoadLogo>ANNOVIEW</LoadLogo>
                        {load['value'] === ANNOTREE_INTERMEDIATE &&
                            <LoadBar now={progress} />}

                        <LoadText>
                            {except
                                ? "Looks like it's taking longer than expected. Please wait as it's still fetching."
                                : showText()}
                            {load['value'] === ANNOTREE_INTERMEDIATE &&
                                <p> &nbsp; If your search request is still in the queue, the progress bar will stay at 0%.</p>
                            }

                        </LoadText>
                    </Col>
                </Row>
            </Container>
        </Section>
    );
};

export default Loading;
